import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ApiPathsService } from 'src/app/api-paths.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-images-list',
  templateUrl: './images-list.component.html',
  styleUrls: ['./images-list.component.scss']
})
export class ImagesListComponent implements OnInit {
  @Input() settings: any;
  @Input() selectedItems: any[] = [];
  @Output() selectedItemsChange = new EventEmitter<any[]>();

  private filtroChange$ = new Subject<any>();

  public items: any[] = [];
  public totalItems = 0;
  public page : number;
  public pageSize : number;
  public filters: any = {};
  public showList : boolean = false;
  public showFilters : boolean = true;

  defaultSettings = {
    singleSelection: false,
    idField: "id",
    textField: "text",
    descriptionField: "subtitle",
    codeField: "code",
    disabledField: "isDisabled",
    enableCheckAll: true,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    searchPlaceholderText: "Search",
    noDataAvailablePlaceholderText: "No data available",
    noFilteredDataAvailablePlaceholderText: "No filtered data available",
    images: [
      {
        idImage: 'id',
        imageField: 'path',
        height: '100',
        width: '100'
      }
    ],
    endpoint: '/prodotti/list',
    parameters: {orderByNome : "asc"},
  };

  constructor(private api: ApiPathsService) {}

  ngOnInit(): void {
    this.settings = this.settings ?? this.defaultSettings;
    this.page = this.settings.defaultPage ?? 1;
    this.pageSize = this.settings.defaultSize ?? 10;
    this.filters = { ...this.settings.parameters };
    console.log("Selected", this.selectedItems)
    this.toggleList()

    this.filtroChange$
    .pipe(debounceTime(500))
    .subscribe(() => this.Refresh());

  }

  Refresh() {
    this.filters.marca = this.filters?.marcaObject?.label
    const payload = {
      ...this.filters,
      page: this.settings.defaultPage ? this.page : undefined,
      size: this.settings.defaultSize ? this.pageSize : undefined,
    };


    const campi = this.settings.CampiAggiuntivi.map(x => {
      if (["singleDropdown", "multiselectDropdown"].includes(x.inputType)) {
        return x.OutputField;
      } else {
        return x.oggetti.find((y: string) => y);
      }
    });
    console.log("Filtri", this.filters);
    console.log("Payload", payload, "excluded: ", this.settings?.excludeIds);
    if(campi.some((campo: string) => {
      console.log("CAMPO", this.filters[campo]);
      return !!this.filters[campo];
    }))
      this.api.ClassicPost(this.settings.endpoint, payload).subscribe(data => {
        this.items = [
          ...this.selectedItems,
          ...data.data
            .filter((item: any) => !this.settings?.excludeIds?.includes(item['id']))
            .filter(item=> !this.selectedItems.some(sel => sel[this.settings.idField] === item[this.settings.idField]))
            .map((item: any) => ({...item, subtitle: item['marcaObject']?.label, isSelected: false}))
      ];

        this.selectedItems = this.items.filter(i => i.isSelected);
        this.totalItems = data.total;
      });
    else {
      this.items = [...this.selectedItems,]
      this.totalItems = 0;
    }
  }


  toggleItem(item: any) {
    if (this.settings?.disableIds.includes(item[this.settings.idField])) return;
    if (this.settings.singleSelection) {
      item.isSelected = !item.isSelected;
      if(item.isSelected)
        this.selectedItems = [item];
      else{
        this.selectedItems = [];
        this.page = 1;
        this.Refresh();
        console.log("Entro");
      }
      this.toggleList();
    } else {
      item.isSelected = !item.isSelected;
      this.selectedItems = this.items.filter(i => i.isSelected);
      this.toggleList();
    }
    this.selectedItemsChange.emit(this.selectedItems);
  }

  selectAll() {
    this.items.forEach(i => i.isSelected = true);
    this.selectedItems = [...this.items];
    this.selectedItemsChange.emit(this.selectedItems);
  }

  unSelectAll() {
    this.items.forEach(i => i.isSelected = false);
    this.selectedItems = [];
    this.selectedItemsChange.emit(this.selectedItems);
  }

  onPageChange(page: number) {
    this.page = page;
    this.Refresh();
  }

  applyFilters() {
    console.log("Aggiorno");
    this.page = 1;
    this.Refresh();
  }

  onFiltroChange(item: { OnChange: string; Event: any; CampoAggiuntivo?: any }) {

    this.page = 1;
    this.filtroChange$.next(item);
  }

  getImageLink(id: string){
    if(!id) return 'assets/images/gallery/NoImageAvailable.png'
    return this.api.getBaseAPI() + '/file/image/' + id

  }

  toggleList() {
     if(!this.selectedItems.length || !this.settings.singleSelection ){
        this.showFilters = true;
        const campi = this.settings.CampiAggiuntivi.map(x => {
          if (["singleDropdown", "multiselectDropdown"].includes(x.inputType)) {
            return x.OutputField;
          } else {
            return x.oggetti.find((y: string) => y);
          }
        });

        return this.selectedItems?.length || campi.some((campo: string) => {
          console.log("CAMPO", this.filters[campo]);
          return !!this.filters[campo];
        });
      }
    else{
      this.items = this.selectedItems;
      this.items.map(i => i.isSelected = true);
      this.showFilters = false
      return true;
    }
  }



}
